// @ts-nocheck
// Images
import backgroundImage from "assets/images/curved-images/white-curved.jpeg";

function card(theme, ownerState) {
  const { borders, functions, transitions, breakpoints } = theme;
  const { miniSidenav } = ownerState;

  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    minWidth: "auto",
    backgroundImage: `url(${backgroundImage})`,
    backgroundPosition: "50%",
    backgroundSize: "cover",
    borderRadius: borderRadius.xl,
    boxShadow: "none",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",

    [breakpoints.up("xl")]: {
      maxHeight: miniSidenav ? pxToRem(64) : "none",
      minHeight: miniSidenav ? pxToRem(64) : pxToRem(132),
      transition: transitions.create(["max-height", "min-height"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
  };
}

function cardContent(theme, ownerState) {
  const { palette, functions, borders } = theme;
  const { white, dark, gradients, primary } = palette;
  const { linearGradient, rgba } = functions;
  const { borderRadius } = borders;

  return {
    color: white.main,
    position: "relative",
    zIndex: 2,
    width: "100%",
    flex: 1,
    minHeight: "inherit",
    p: 2,
    borderRadius: borderRadius.xl,
    overflow: "hidden",

    "&::after": {
      content: '""',
      backgroundImage: linearGradient(
        rgba(primary.focus, 0.82),
        rgba(gradients.primary.state, 0.82)
      ),
      display: "block",
      height: "100%",
      width: "100%",
      borderRadius: borderRadius.xl,
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0.92,
      zIndex: -1,
    },

    boxShadow: `inset 0 0 0 1px ${rgba(white.main, 0.08)}`,

    "& .MuiButton-root": {
      color: dark.main,
    },

    "&:last-child": {
      pb: 2,
    },
  };
}

const cardIconBox = {
  display: "grid",
  placeItems: "center",
  transition: ({ transitions }) =>
    transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),
};

function cardIcon(theme, ownerState) {
  const { functions, palette } = theme;
  const { linearGradient } = functions;
  const { gradients, transparent } = palette;

  return {
    backgroundImage: linearGradient(gradients.primary.main, gradients.primary.state),
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: transparent.main,
  };
}

export { card, cardContent, cardIconBox, cardIcon };
